import { Card, Box, styled, Avatar, Typography } from '../../../../base';

export const StyledSocialCard = styled(Card)(({ theme }) => ({
    borderRadius: 16,
    border: `1px solid ${theme.palette.grey[300]}`,
    padding: theme.spacing(3),
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
    borderRadius: 0,
    width: 45,
    height: 45,
    marginBottom: theme.spacing(1),
}));

export const StyledName = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.common.black,
}));

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 3,
    marginTop: theme.spacing(1),
}));
